import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
import n from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = {}, c = {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function f(i, e) {
  return o(), l("svg", c, [...e[0] || (e[0] = [
    t("rect", {
      fill: "#11907C",
      height: "20",
      rx: "4",
      width: "20"
    }, null, -1),
    t("path", {
      "clip-rule": "evenodd",
      d: "M10.023 6.338h1.852V4.482h-1.856v1.854H8.167v1.856h1.852v1.853H8.167v1.856h.002v1.85a1.853 1.853 0 0 0 1.85 1.852 1.853 1.853 0 0 0 1.852-1.852V11.9h-1.848v-1.853h1.852V8.19h-1.852V6.338Zm-.907 6.509v.904a.905.905 0 1 0 1.808 0v-.904H9.116Z",
      fill: "#fff",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const d = /* @__PURE__ */ n(r, [["render", f]]);
export {
  d as default
};
